// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { DataCacheTool } from "../DataCacheTool.js";
import { CustomEvent } from "../../../Utils/CustomEvents.js";

/// <summary>
/// TradingToolBaseDataCacheTool - базовая для всех торговых
/// </summary>
export let TradingToolBaseDataCacheTool = function ()
{
    this.ToolType = DataCacheToolToolType.TradingTool;
    this.OnUpdate = new CustomEvent();
    this.InitPoints(1);
}
TradingToolBaseDataCacheTool.prototype = Object.create(DataCacheTool.prototype);

TradingToolBaseDataCacheTool.prototype.MinPointsCount = function ()
{
    return 1;
}